module.exports = __webpack_public_path__ + "static/logo_light-fdff4227842054e605416dcaa8de80da.png";